import api from './../lib/api';

export const AUTH = 'playgrounds/auth/login';
export const AUTH_FAILURE = 'playgrounds/auth/failure';

function reducer(state = {}, action) {
  if (action.type === AUTH) {
    return { ...action.payload };
  }
  return state;
}

// два сценария - пользователь логиниться через логинку
// или же токен берем из local storage при старте приоложения

export const refreshAuth = async () => {
  const token = window.localStorage.getItem('access_token');
  if (!token) {
    throw new Error('Токен не найден');
  }
  api.setToken(token);
  const user = await api.getUser();
  return authAction(user, token);
};

export const authorize = async (login, password) => {
  // Проверяем, что параметры не пустые
  if (!login || !password) {
    throw new Error('Логин и пароль обязательны');
  }

  try {
    const result = await api.auth(login, password);
    const token = result.access_token;
    api.setToken(token);
    if (window.localStorage) {
      window.localStorage.setItem('access_token', token);
    }

    const user = await api.getUser();
    return authAction(user, token);
  } catch (error) {
    console.error('Ошибка авторизации:', error);
    throw error;
  }
};

const authAction = (user, token) => {
  if (user.role !== 'administrator' && user.role !== 'moderator') {
    throw new Error('Запрещенная роль пользователя');
  }
  return {
    type: AUTH,
    payload: {
      login: user.login,
      role: user.role,
      userId: user.id,
      name: user.name || user.Name || '',
      lastname: user.lastname || user.Lastname || user.lastName || user.LastName || '',
      token,
      isAuthorized: true,
    },
  };
};

export default reducer;
